export default __webpack_public_path__ + "static/media/luona_logo.985a18d7.svg";